
<div class="document-preview">
	<header class="document-preview-header">
		<i class="pi pi-file" aria-hidden="true"></i>
		<span>{{ file?.fileName || 'Document preview' }}</span>
	</header>

	<div class="document-preview-workspace">
		<div
			id="pms-row-supporting-document-pdf"
			class="document-preview-pdf"
			[hidden]="(kind !== 'pdf' && kind !== 'excel') || !!previewError"
		></div>

		<div
			*ngIf="kind === 'image' && imageSource && !previewError"
			class="document-preview-image"
		>
			<img
				[src]="imageSource"
				[alt]="file?.fileName || 'Supporting document'"
			/>
		</div>

		<div
			*ngIf="isLoading"
			class="document-preview-overlay"
			role="status"
		>
			<i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
			<p>Loading document preview...</p>
		</div>

		<div
			*ngIf="previewError"
			class="document-preview-state"
			role="alert"
		>
			<i class="pi pi-exclamation-circle" aria-hidden="true"></i>
			<h2>Preview unavailable</h2>
			<p>{{ previewError }}</p>

			<button type="button" (click)="retry()">
				Try again
			</button>
		</div>

		<div
			*ngIf="kind === 'unsupported' && !previewError"
			class="document-preview-state"
		>
			<i class="pi pi-file" aria-hidden="true"></i>
			<h2>Preview not available</h2>
			<p>
				This file format cannot be displayed inline.
				You can download the original file.
			</p>
		</div>
	</div>
</div>
